import React, { Component } from 'react';
import { ContainerLoading, ContainerLoadingContent } from './styles';

const loading = '/images/loading-blue.gif';

class Loading extends Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <ContainerLoading>
                <ContainerLoadingContent>
                    <img alt='loading' src={loading}/>
                </ContainerLoadingContent>
            </ContainerLoading>
        )
    }
}

// function ButtonContinue() {

//   return   ;
// }
 
export default Loading;
